import { useAuthentication } from "../AuthenticationProvider"
import { useEffect } from "react"
import { HttpStatusCodes } from "../../../../utils/HttpStatusCodes"

export default function useQueryExpirationHandler(query) {
  const { handleSessionExpiration } = useAuthentication()

  useEffect(() => {
    if (query.isError && query.error.statusCode === HttpStatusCodes.UNAUTHORIZED) {
      handleSessionExpiration()
    }
  }, [query.isError])
}
